import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge'
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import orderDeliveryWindowsAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-delivery-windows/order-delivery-windows.entity';
import { AssignHourModalComponent } from './assign-hour/assign-hour.component';
import { FrecuencyModalComponent } from './frecuency/frecuency.component';
import { SubRouteDeliveryTimesService } from './sub-route-delivery-times.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { PermissionDirective } from 'app/core/permission/directives/permission.directive';
import { HasPermissionPipe } from 'app/core/permission/pipes/has-permission.pipe';
import { PermissionService } from 'app/core/permission/services/permission.service';
import { ROUTES_PERMISSIONS } from 'app/common/constants/permission';

@Component({
  selector: 'app-add-subroute-delivery-times-modal',
  styleUrl: './sub-route-delivery-times.component.scss',
  templateUrl: './sub-route-delivery-times.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatBadgeModule,
    MatSlideToggle,
    PermissionDirective,
    HasPermissionPipe,
  ],
})
export class AddSubRouteDeliveryTimes {

  readonly PERMISSIONS_DELIVERY_WINDOWS = ROUTES_PERMISSIONS.DELIVERY_WINDOWS;

  openFormAdd = false

  formAddList = {
    id: null,
    masterUserId: '',
    businessPartnerFunctionId: ''
  }
  listCollaboratorsAdd:orderDeliveryWindowsAttributes[] = []

  //currentCreateSubRouteCollaborator: ICreateSubRouteDeliveryTimes = this.initializeCreateSubRouteCollaborator();
  currentUpdateSubRouteCollaborator: orderDeliveryWindowsAttributes | undefined;

  currentCreateSubRouteDeliveryTimes: orderDeliveryWindowsAttributes = this.initializeCreateSubRouteDeliveryTimes();
  
  constructor(
    private dialog: MatDialog,
    private readonly subRouteDeliveryTimesService: SubRouteDeliveryTimesService,
    public dialogRef: MatDialogRef<AddSubRouteDeliveryTimes>,
    private snackBar: MatSnackBar,
    private readonly permissionService: PermissionService,

    @Inject(MAT_DIALOG_DATA) public data: any // Optional: if you want to pass data
  ) {

  }

  ngAfterViewInit(): void {
    //this.fetchAllBusinessPartner();
    //this.fetchAllUserMaster();
    this.getListIOrderDeliveryWindows();
  }

  private getListIOrderDeliveryWindows(): void {
    if(this.data){
      this.listCollaboratorsAdd = this.data.orderDeliveryWindows;
    }
  }

  private initializeCreateSubRouteDeliveryTimes(): orderDeliveryWindowsAttributes {
    return {
      days: [],
      hourStart: null,
      hourEnd: null,
      minutesStart: 0,
      minutesEnd: 0,
      numberOfHoursToDelivery: 0,
    };
  }


  
  save() {
    const dataToSend = Object.entries(this.currentCreateSubRouteDeliveryTimes)
    .reduce((acc, [key, value]) => {
      if (value !== '' && !(Array.isArray(value) && value.length === 0)) { 
        acc[key] = value;
      }
      return acc;
    }, {});
    this.dialogRef.close(dataToSend);
  }

  resetFormAddListCollaborators() {

  }

  // El gate del template evita el click, pero el metodo tambien se alcanza por
  // otros caminos. La validacion va en los dos lados.
  private checkIfHasPermission(permission: string, errorMessage: string): boolean {
    const has = this.permissionService.has(permission);
    if (!has) {
      this.snackBar.open(errorMessage, "Cerrar", { duration: 5000 });
    }
    return has;
  }

  onAddToListDeliveryTimes() {
    if (!this.checkIfHasPermission(this.PERMISSIONS_DELIVERY_WINDOWS.CREATE, "No tienes permisos para crear ventanas horarias.")) {
      return;
    }


    if(this.currentCreateSubRouteDeliveryTimes.days.length == 0){
      this.snackBar.open(
        "Seleccione una frecuencia.",
        "Cerrar",
        { duration: 5000, verticalPosition: "top" }
      );
      return;
    }

    if(!this.currentCreateSubRouteDeliveryTimes.hourStart || this.currentCreateSubRouteDeliveryTimes.hourStart == '' ||
      !this.currentCreateSubRouteDeliveryTimes.hourEnd || this.currentCreateSubRouteDeliveryTimes.hourEnd == ''
    ){
      this.snackBar.open(
        "Seleccione un horario.",
        "Cerrar",
        { duration: 5000, verticalPosition: "top" }
      );
      return;
    }

    if(this.currentCreateSubRouteDeliveryTimes.numberOfHoursToDelivery <= 0){
      this.snackBar.open(
        "Complete una hora de entrega correcta.",
        "Cerrar",
        { duration: 5000, verticalPosition: "top" }
      );
      return;
    }

    this.subRouteDeliveryTimesService.set(this.data._id, this.currentCreateSubRouteDeliveryTimes)
      .subscribe({
        next: () => {
          this.snackBar.open("Horario creado con éxito", "Cerrar", {
            duration: 5000,
            verticalPosition: "top",
          });
          this.openFormAdd = false
          this.currentCreateSubRouteDeliveryTimes = this.initializeCreateSubRouteDeliveryTimes();
          this.subRouteDeliveryTimesService
            .findBySubRouteId(this.data._id.toString())
            .subscribe((res) => {
              this.data.orderDeliveryWindows = res?.data;
              this.listCollaboratorsAdd = this.data.orderDeliveryWindows
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el horario",
            "Cerrar",
            { duration: 5000, verticalPosition: "top" }
          );
        },
      })
  }

  onStatusChange(event: boolean, element){
    const updatedStatusId = event ? 1 : 0;
    element.statusId = updatedStatusId;
  }

  onUpdateDeliveryTime(element, i){
    if (!this.checkIfHasPermission(this.PERMISSIONS_DELIVERY_WINDOWS.UPDATE, "No tienes permisos para editar ventanas horarias.")) {
      return;
    }

    element.isEditMode = true;

  }

  onSaveDeliveryTime(element, i){
    if (!this.checkIfHasPermission(this.PERMISSIONS_DELIVERY_WINDOWS.UPDATE, "No tienes permisos para editar ventanas horarias.")) {
      return;
    }


    if(element.days.length == 0){
      this.snackBar.open(
        "Seleccione una frecuencia.",
        "Cerrar",
        { duration: 5000, verticalPosition: "top" }
      );
      return;
    }

    if(!element.hourStart || element.hourStart == '' ||
      !element.hourEnd || element.hourEnd == ''
    ){
      this.snackBar.open(
        "Seleccione un horario.",
        "Cerrar",
        { duration: 5000, verticalPosition: "top" }
      );
      return;
    }

    if(element.numberOfHoursToDelivery <= 0){
      this.snackBar.open(
        "Complete una hora de entrega correcta.",
        "Cerrar",
        { duration: 5000, verticalPosition: "top" }
      );
      return;
    }
    
    element.isEditMode = false;

    this.subRouteDeliveryTimesService.updateDT(this.data._id, element._id, element).subscribe({
      next: () => {
        this.snackBar.open("Horario actualizado con éxito", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        this.subRouteDeliveryTimesService
          .findBySubRouteId(this.data._id.toString())
          .subscribe((res) => {
            this.data.orderDeliveryWindows = res?.data;
            this.listCollaboratorsAdd = this.data.orderDeliveryWindows
          });
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el horario",
          "Cerrar",
          { duration: 5000, verticalPosition: "top" }
        );
      },
    })
  }

  onDeleteDeliveryTime(element, i) {
    if (!this.checkIfHasPermission(this.PERMISSIONS_DELIVERY_WINDOWS.DELETE, "No tienes permisos para eliminar ventanas horarias.")) {
      return;
    }

    this.subRouteDeliveryTimesService.delete(this.data._id, element._id).subscribe({
      next: () => {
        this.snackBar.open("Horario eliminado con éxito", "Cerrar", {
          duration: 5000,
          verticalPosition: "top",
        });
        this.subRouteDeliveryTimesService
          .findBySubRouteId(this.data._id.toString())
          .subscribe((res) => {
            this.data.orderDeliveryWindows = res?.data;
            this.listCollaboratorsAdd = this.data.orderDeliveryWindows
          });
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al eliminar el horario",
          "Cerrar",
          { duration: 5000, verticalPosition: "top" }
        );
      },
    })
  }

  openScheduleModal(action:string, data?:orderDeliveryWindowsAttributes){
    const dialogRef = this.dialog.open(AssignHourModalComponent, {
      panelClass: ".form-modal-interlocutor",
      data: action == 'create' ? this.currentCreateSubRouteDeliveryTimes : data,
      width: "500px",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if(action == 'create'){
          this.currentCreateSubRouteDeliveryTimes = result;
        }else{
          data = result;
        }
      }
    })
  }

  openFrecuencyModal(action:string, data?:orderDeliveryWindowsAttributes){
    const dialogRef = this.dialog.open(FrecuencyModalComponent, {
      panelClass: ".form-modal-interlocutor",
      data: action == 'create' ? this.currentCreateSubRouteDeliveryTimes : data,
      width: "500px",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if(action == 'create'){
        this.currentCreateSubRouteDeliveryTimes = result;
      }else{
        data = result;
      }
    })
  }
  
}
